import { useLanguage } from '../../i18n/hooks/use-language';
import { SearchParam } from '../param';
import { buildQueryParams } from '../services/query-param-builder';

export const usePathBuilder = () => {
  const currentLanguage = useLanguage();
  return {
    homePath: () => `/${currentLanguage}`,
    searchArticlePath: (articleId: string) => `/${currentLanguage}${buildQueryParams([SearchParam.query, articleId])}`,
    registerPath: () => `/${currentLanguage}/register`,
    articlePath: (pimArticleId: string) => `/${currentLanguage}/article/${pimArticleId}`,
    cartPath: () => `/${currentLanguage}/cart`,
    cartFinalizePath: () => `/${currentLanguage}/cart/finalize`,
    invoiceDetailPath: (recordNo: string) => `/${currentLanguage}/profile/invoices/${recordNo}`,
    profilePath: () => `/${currentLanguage}/profile`,
    profileSettingsPath: () => `/${currentLanguage}/profile/settings`,
    formAddressMutation: (companyName?: string) => {
      return `/${currentLanguage}/form/address-mutation${buildQueryParams([SearchParam.companyName, companyName])}`;
    },
    formNewDeliveryAddress: (companyName?: string) => {
      return `/${currentLanguage}/form/new-delivery-address${buildQueryParams([SearchParam.companyName, companyName])}`;
    },
    formNewUserForExistingCustomer: (companyName?: string) => {
      return `/${currentLanguage}/form/new-user${buildQueryParams([SearchParam.companyName, companyName])}`;
    },
    formDeleteUser: (emailToDelete: string) => {
      return `/${currentLanguage}/form/delete-user${buildQueryParams([SearchParam.emailToDelete, emailToDelete])}`;
    },
    formInquiryAboutArticle: (
      articleId: string,
      {
        weightKg,
        container,
      }: {
        weightKg?: string;
        container?: string;
      } = {},
    ) => {
      return `/${currentLanguage}/form/inquiry-about-article${buildQueryParams(
        [SearchParam.articleId, articleId],
        [SearchParam.weightKg, weightKg],
        [SearchParam.container, container],
      )}`;
    },
    formArticleNotFound: () => `/${currentLanguage}/form/article-not-found`,
    scanBarcode: () => `/${currentLanguage}/scan-barcode`,
    orderSampleSheet: (articleId: string, storedAddressId: string | null) =>
      `/${currentLanguage}/form/order-sample-sheet${buildQueryParams([SearchParam.articleId, articleId], [SearchParam.storedAddressId, storedAddressId])}`,
    serviceRequest: (articleId: string) =>
      `/${currentLanguage}/form/service-request${buildQueryParams([SearchParam.articleId, articleId])}`,
  };
};
